var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"webform-wrapper"}},[_c('input',{attrs:{"id":"web-form-status","hidden":"","readonly":""}}),_c('script',{attrs:{"type":"text/json","id":"external-web-form-css"}},[_vm._v(" { \"webFormBody\": { \"maxWidth\": \"450px\" }, \"webFormBtnSubmit\": { \"backgroundColor\": \"#00A82D\" } } ")])])
}]

export { render, staticRenderFns }